import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

const toneMap: Record<string, string> = {
  primary: "bg-primary-100 text-primary-600",
  accent: "bg-accent-100 text-accent-600",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function CategoryQuickLinks() {
  return (
    <section className="max-w-[1280px] mx-auto px-4 md:px-6 py-10">
      <div className="flex items-end justify-between mb-5">
        <div>
          <h2 className="font-heading font-extrabold text-xl md:text-2xl text-foreground-950">探索内容分类</h2>
          <p className="mt-1 text-sm text-foreground-500">挑选你感兴趣的话题，一键直达专属频道</p>
        </div>
      </div>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to={`/category/${cat.slug}`}
            className="group flex items-center gap-4 p-5 rounded-lg bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
          >
            <span className={`w-14 h-14 flex items-center justify-center rounded-lg text-2xl ${toneMap[cat.tone]}`}>
              <i className={cat.icon} aria-hidden="true"></i>
            </span>
            <div className="flex-1">
              <h3 className="font-heading font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors">
                {cat.name}
              </h3>
              <p className="mt-1 text-xs text-foreground-500 line-clamp-2">{cat.intro}</p>
            </div>
            <i className="ri-arrow-right-line text-foreground-300 group-hover:text-primary-500 transition-colors" aria-hidden="true"></i>
          </Link>
        ))}
      </div>
    </section>
  );
}